'use strict';

/**
 * Filter component view
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var FilterComponentView = require('modules/base/views/layout/filter-component');

var template = require('modules/collection/templates/components/filter/range-slider.hbs');
var templateGraph = require('modules/base/templates/partials/filter-range-value-distribution-graph.hbs');

require('jquery-nouislider');

var RangeSliderView = FilterComponentView.extend({
    template: template,

    title: 'Range Slider',

    fractionDigits: 0,

    ui: {
        'rangeStart': '.component-range-start',
        'rangeEnd': '.component-range-end',
        'clearRange': '.clear-range',
        'rangeSlider': '.range-slider',
    },

    events: {
        'change @ui.rangeSlider': 'change',
        'slide @ui.rangeSlider': 'updateSlider',
        'change @ui.rangeStart': 'change',
        'change @ui.rangeEnd': 'change',
        'click @ui.clearRange': 'clearRange',
    },

    viewData: {
        unit: function() { return this.getOption('options').unit; },
    },

    onRender: function() {
        FilterComponentView.prototype.onRender.apply(this, arguments); //sets rangeStart.val() and rangeEnd.val()

        if (!this.isFilterUseful()) {
            this.$el.hide();

            return;
        }

        this.ui.rangeSlider.noUiSlider({
            connect: true,
            start: [
                this.getStartValue(),
                this.getEndValue(),
            ],
            range: {
                min: this.getRangeMin(),
                max: this.getRangeMax(),
            },
            format: wNumb({
                decimals: this.getOption('options').fractionDigits,
            }),
        }).noUiSlider_pips({
            mode: 'positions',
            values: [0, 20, 40, 60, 80, 100],
            density: 10,
            format: wNumb({
                decimals: this.getOption('options').fractionDigits,
            }),
        });

        this.ui.rangeSlider.Link('lower').to(this.ui.rangeStart);
        this.ui.rangeSlider.Link('lower').to(this.ui.rangeSlider.find('.noUi-handle-lower'));
        this.ui.rangeSlider.Link('upper').to(this.ui.rangeEnd);
        this.ui.rangeSlider.Link('upper').to(this.ui.rangeSlider.find('.noUi-handle-upper'));

        this.ui.rangeSlider.prepend(this.renderDistributionGraph());

        this.updateSlider();
    },

    isFilterUseful: function() {
        return _.uniq(_.compact(this.getRangeValues())).length > 1;
    },

    change: function() {
        this.ui.rangeSlider.val([this.ui.rangeStart.val(), this.ui.rangeEnd.val()]);
        this.updateSlider();

        FilterComponentView.prototype.change.apply(this, arguments);
    },

    updateSlider: function() {
        // var rangeValues = this.ui.rangeSlider.val();

        //highlight distribution graph
        if (this.isFilterDefault()) {
            this.ui.rangeSlider.removeClass('active');
            this.ui.rangeSlider.find('.range-distribution')
                .removeAttr('data-lower')
                .removeAttr('data-upper');
        } else {
            var lowerHandleStyle = this.ui.rangeSlider.find('.noUi-connect').attr('style');
            var upperHandleStyle = this.ui.rangeSlider.find('.noUi-background').attr('style');
            var lowerPercantage = lowerHandleStyle ? lowerHandleStyle.replace(/left:\s*(.*)?%;/g, '$1') : 0;
            var upperPercantage = upperHandleStyle ? upperHandleStyle.replace(/left:\s*(.*)?%;/g, '$1') : 0;
            var lowerSlot = _.ceil(lowerPercantage * (70 / 100), this.getOption('options').fractionDigits);
            var upperSlot = _.ceil(upperPercantage * (70 / 100), this.getOption('options').fractionDigits);

            this.ui.rangeSlider.addClass('active');
            this.ui.rangeSlider.find('.range-distribution')
                .attr('data-lower', lowerSlot)
                .attr('data-upper', upperSlot);
        }
    },

    rangeValuesMapFunction: function(item) {
        var value = item.getNormalizedValue(this.getModelAttribute());

        if (value !== null) {
            return value;
        }
    },

    isFilterDefault: function() {
        return this.getStartValue() === this.getRangeMin() && this.getEndValue() === this.getRangeMax();
    },

    getFilters: function() {
        var filters = [];

        var startValue = this.getStartValue();
        var endValue = this.getEndValue();

        if (
            startValue !== this.getRangeMin() ||
            endValue !== this.getRangeMax()
        ) {
            filters.push({value: startValue + '~' + endValue, displayName: startValue + ' — ' + endValue + ' ' + this.getOption('options').unit});
        }

        return filters;
    },

    setFilters: function(filters) {
        var rangeValues = filters.split('~');

        this.ui.rangeStart.closest('.filter-range').removeClass('active');

        if (filters || !this.isFilterDefault()) {
            this.ui.rangeStart.val(rangeValues[0]);
            this.ui.rangeEnd.val(rangeValues[1]);

            this.ui.rangeStart.closest('.filter-range').addClass('active');
        }
    },

    clearRange: function(event) {
        this.ui.rangeStart.val(this.getRangeMin());
        this.ui.rangeEnd.val(this.getRangeMax());
        this.change();

        //@todo investigate who calls navigate on button if default is not prevented
        event ? event.preventDefault() : null;
    },

    resetFilters: function() {
        this.clearRange();
    },

    getFilterValueDisplayName: function(value) {
        return value.replace('~', ' — ') + ' ' + this.getOption('options').unit;
    },

    getStartValue: function() {
        var inputValue = this.ui.rangeStart.val().trim();

        return _.floor(parseFloat(inputValue), this.getOption('options').fractionDigits);
    },

    getEndValue: function() {
        var inputValue = this.ui.rangeEnd.val().trim();

        return _.ceil(parseFloat(inputValue), this.getOption('options').fractionDigits);
    },

    getRangeValues: function() {
        if (_.isUndefined(this.rangeValues)) {
            this.rangeValues = this.collection.map(this.rangeValuesMapFunction.bind(this));
        }

        return this.rangeValues;
    },

    getRangeMin: function() {
        if (_.isUndefined(this.rangeMin)) {
            var collectionMinValue = _.min(this.getRangeValues());
            collectionMinValue = collectionMinValue === Infinity ? 0 : collectionMinValue;
            this.rangeMin = _.floor(collectionMinValue, this.getOption('options').fractionDigits);
        }

        return this.rangeMin;
    },

    getRangeMax: function() {
        if (_.isUndefined(this.rangeMax)) {
            var collectionMaxValue = _.max(this.getRangeValues());
            collectionMaxValue = collectionMaxValue === -Infinity ? 10000 : collectionMaxValue;
            this.rangeMax = _.ceil(collectionMaxValue, this.getOption('options').fractionDigits);
        }

        return this.rangeMax;
    },

    renderDistributionGraph: function() {
        var relativeDistribution = _.relativeDistribution(this.getRangeValues(), 70);
        var html = templateGraph({values: relativeDistribution});

        return html;
    },
});

module.exports = RangeSliderView;